const steps = [
  {
    name: 'Start in minutes',
    description:
      'Register your club and set your meeting cadence. No demo call, no setup fee, no credit card',
  },
  {
    name: 'Bring your roster',
    description:
      'Import your members from a CSV or invite them by email - no retyping names into yet another system. On Pro, we’ll help with the move',
  },
  {
    name: 'Run it alongside what you use today',
    description:
      'Keep your spreadsheet or current tool while your club tries Speech Agenda on one real meeting. Switch at your own pace',
  },
  {
    name: 'Your club is never locked in',
    description:
      'The public schedule stays viewable by every member and guest, and your data stays yours. Stay because it works, not because you must',
  },
]

export default function LandingSwitch() {
  return (
    <div className="bg-gray-50 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600">
            Already using something?
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Switching is the easy part
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            You don&apos;t need a migration project - you need one good
            meeting. Start with your next one
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-4">
            {steps.map((step, index) => (
              <div
                key={step.name}
                className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-gray-200">
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-600 text-lg font-bold text-white">
                    {index + 1}
                  </div>
                  {step.name}
                </dt>
                <dd className="mt-2 text-base leading-7 text-gray-600">
                  {step.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
